(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/xperten/javascripts/xperten-choice.js') >= 0) return;  svs.modules.push('/components/sport/xperten/javascripts/xperten-choice.js');
'use strict';

(function (svs) {
  class XpertenChoice extends React.Component {
    componentDidMount() {
      const $el = $("#xperten-".concat(this.props.cost));
      if (this.props.selected) {
        $el.prop('checked', true);
        $('.modal-button-right').prop('disabled', false);
      }
    }
    componentDidUpdate() {
      const $el = $("#xperten-".concat(this.props.cost));
      if (this.props.disabled && $el.prop('checked') === true) {
        $el.prop('checked', false);
        $('.modal-button-right').prop('disabled', true);
      }
    }
    render() {
      const forName = "xperten-".concat(this.props.cost);
      const onClick = _.partial(this.props.onXpertenClick, this.props.cost);
      return React.createElement("div", {
        className: "span6",
        style: {
          padding: 3
        }
      }, React.createElement("div", {
        className: "form-toggle"
      }, React.createElement("input", {
        className: "form-toggle-input form-toggle-challenge form-toggle-radio form-toggle-button",
        disabled: this.props.disabled,
        id: forName,
        name: "xperten-base-group[]",
        onClick: onClick,
        type: "radio"
      }), React.createElement("label", {
        className: "form-label",
        htmlFor: forName
      }, React.createElement("div", {
        className: "form-label-text"
      }, this.props.cost, ' ', "kr"))));
    }
  }
  svs.sport.xperten.XpertenChoice = XpertenChoice;
})(svs);

 })(window);